import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const PageTitleContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1),
  display: "flex",
  justifyContent: "space-between",
}));
